import { DataTable } from "primereact/datatable";
import { useEffect, useRef, useState } from "react";
import { format } from "date-fns";
import { Column } from "primereact/column";
import { Fetch } from "../../shared/Fetch";
import { Dialog } from "primereact/dialog";
import { GeneratedBranchInvoice } from "./GeneratedBranchImvoice";

interface IProps {
    toast: any,
    id?: number,
    open?: boolean,
    setModal: (data: { id: number, singleData: GeneratedBranchInvoice, open: boolean }) => void,
    singleData: GeneratedBranchInvoice
}

interface GeneratedBranchInvoiceConsultantList {
    userType?: number,
    userBranchID?: number,
    userBranchPercentage?: number,
    userBranchAmount?: number,
    calculatedAmount?: number,
    createdOn?: Date,
    is_Invoice_Generated?: boolean,
    invoiceNO?: string,
    fromDate?: Date,
    toDate?: Date,
    consultant_Name?: string,
    vendor_Company_Name?: string,
    invoiceHours?: number,
    company_Name?: string,
    branchName?: string,
}

export const GeneratedBranchInoviceConsultantList = (props: IProps) => {
    const [tableData, setTableData] = useState({ tableData: [], loading: false } as { tableData: Array<GeneratedBranchInvoiceConsultantList>, loading: boolean });
    const dt: any = useRef<any>(null);

    const header = () => {
        return (
            <p>Generated Branch Invoice Consultant List</p>
        );
    }

    const onHide = () => {
        props.setModal({ id: 0, singleData: {}, open: false });
    }

    const loadTableData = async () => {
        setTableData({ tableData: tableData.tableData, loading: true });
        const response = await Fetch("InvoiceTracking/generatedBranchWiseInvoicesConsultantList", "GET", null, `invoiceID=${props.id}`, props.toast);
        if (response) {
            const data: GeneratedBranchInvoiceConsultantList[] = await response.json();
            setTableData({ tableData: data, loading: false });
        } else setTableData({ tableData: tableData.tableData, loading: false });
    }

    useEffect(() => {
        if (props.open && props.id) {
            loadTableData();
        }
    }, [props.open]);
    //BranchConsultantGeneratedInvoice.tsx
    return (
        <>
            <Dialog visible={props.open} style={{ width: '80vw' }} header="Generated Branch Invoice Consultant List" modal className="p-fluid" onHide={onHide}>
                <DataTable style={{ border: '1px solid rgba(105,105,105,0.17)', borderTopWidth: "0", marginTop: "5px" }}
                    ref={dt} size="small" stripedRows showGridlines exportFilename={format(new Date(), 'dd-MM-yyyy hh_mm_ss a').toUpperCase()}
                    value={[props.singleData]}
                    emptyMessage="No Branches found."
                    // header={header}
                    loading={tableData.loading}
                    selectionMode={'checkbox'}
                >
                    <Column field="userType" header="Service Type" body={(rowData: GeneratedBranchInvoiceConsultantList) => <p>{rowData.userType === 2 ? "Sales" : "Recruiter"}</p>} />
                    <Column field="company_Name" header="Company Name" />
                    <Column field="branchName" header="Branch Name" />
                </DataTable>
                <DataTable style={{ border: '1px solid rgba(105,105,105,0.17)', borderTopWidth: "0", marginTop: "5px" }}
                    ref={dt} size="small" stripedRows showGridlines exportFilename={format(new Date(), 'dd-MM-yyyy hh_mm_ss a').toUpperCase()}
                    value={tableData.tableData}
                    emptyMessage="No Branches found."
                    // header={header}
                    loading={tableData.loading}
                    selectionMode={'checkbox'}
                >
                    {/* <Column field="userType" header="Service Type" body={(rowData: GeneratedBranchInvoiceConsultantList) => <p>{rowData.userType === 2 ? "Sales" : "Recruiter"}</p>} />
                    <Column field="company_Name" header="Company Name" />
                    <Column field="branchName" header="Branch Name" /> */}
                    <Column field="invoiceNO" header="#Invoice" style={{ minWidth: '8rem', maxWidth: '8rem' }} />
                    <Column field="fromDate" header="From Date" style={{ minWidth: '8rem', maxWidth: '8rem' }} body={(rowData: GeneratedBranchInvoiceConsultantList) => {
                        let date;
                        if (rowData.fromDate) date = format(new Date(rowData.fromDate), 'dd/MM/yyyy').toUpperCase();
                        else date = "";
                        return (<p>{date}</p>);
                    }} />
                    <Column field="toDate" header="To Date" style={{ minWidth: '8rem', maxWidth: '8rem' }} body={(rowData: GeneratedBranchInvoiceConsultantList) => {
                        let date;
                        if (rowData.toDate) date = format(new Date(rowData.toDate), 'dd/MM/yyyy').toUpperCase();
                        else date = "";
                        return (<p>{date}</p>);
                    }} />
                    <Column field="consultant_Name" style={{ minWidth: '8rem', maxWidth: '8rem' }} header="Consultant Name" />
                    <Column field="vendor_Company_Name" style={{ minWidth: '9rem', maxWidth: '9rem' }} header="Client Company Name" />
                    <Column field="invoiceHours" header="Inv Hrs" />
                    <Column field="calculatedAmount" header="Inv Amnt ($)" body={(rowData) => <p>{rowData.calculatedAmount}</p>} />
                    <Column field="userBranchPercentage" header="Branch (%)" body={(rowData) => <p>{rowData.userBranchPercentage}</p>} />
                    <Column field="userBranchAmount" header="Branch Amount ($)" body={(rowData) => <p>{Number(rowData.userBranchAmount).toFixed()}</p>} />
                </DataTable>
            </Dialog>
        </>
    );
}